import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { KineticLines, Reveal, SectionLabel } from "../Reveal";

export default function ServiceCTA({ service, title, copy, cta }) {
  return (
    <section className="relative bg-navy-950 text-white overflow-hidden grain" data-testid={`service-cta-${service}`}>
      <div className="absolute inset-0 bg-arch-dark" aria-hidden="true" />
      <svg className="absolute inset-0 w-full h-full opacity-40" viewBox="0 0 1440 400" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
        <path d="M-100 300 C 320 200, 620 380, 960 240 C 1220 130, 1340 240, 1560 140" stroke="#15B8A6" strokeWidth="1.6" strokeDasharray="5 11" className="animate-dashFlow" />
        <path d="M-100 220 C 340 140, 660 300, 1000 180 C 1240 90, 1380 180, 1560 90" stroke="#3D6BA8" strokeWidth="1.2" strokeDasharray="4 12" className="animate-dashFlow" style={{ animationDelay: "0.7s" }} />
      </svg>
      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-24 text-center">
        <SectionLabel dark>Next Step</SectionLabel>
        <KineticLines
          as="h2"
          className="mt-5 font-display font-extrabold tracking-tightest text-2xl sm:text-4xl lg:text-5xl leading-[1.1] text-white"
          lines={title}
        />
        <Reveal delay={0.1}>
          <p className="mt-5 text-base md:text-lg leading-relaxed text-ice/75 max-w-2xl mx-auto">{copy}</p>
        </Reveal>
        <Reveal delay={0.18}>
          <Link
            to={`/contact?service=${service}`}
            data-testid={`service-cta-${service}-button`}
            className="group mt-8 inline-flex items-center gap-2 bg-teal text-navy font-bold text-[15px] px-8 py-4 rounded-full transition-all duration-300 hover:bg-teal-bright hover:-translate-y-0.5 shadow-[0_16px_40px_-12px_rgba(21,184,166,0.5)]"
          >
            {cta}
            <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
